import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=01bee578&scoped=true&"
import script from "./AppContent.vue?vue&type=script&lang=js&"
export * from "./AppContent.vue?vue&type=script&lang=js&"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=01bee578&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bee578",
  null
  
)

export default component.exports